import React, { useEffect } from 'react';
import { handleTitle } from '../../../actions/interface';
import { useAppDispatch } from '#app/hooks/useAppStore';
import { CenteredWrapper, Container } from '../../../pages/styles';
import { Img, ImgContainer, NotFoundContainer, Text, Title } from './styles';
import { Button } from 'finform';
import { useLocation } from 'react-router-dom';
import { routes } from '#app/constants/routes';

const UnexpectedError = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(handleTitle('Ошибка'));
  }, [dispatch]);

  return (
    <Container
      style={{
        margin: '20px auto 0 auto',
      }}
    >
      <CenteredWrapper>
        <NotFoundContainer>
          <ImgContainer>
            <Img src={require('./images/swan.svg')} />
          </ImgContainer>
          <Title>Ошибка</Title>
          <Text>Сообщите нам об ошибке info@whiteswan.finance</Text>
          <Text></Text>
          <Button
            className="style1"
            type="href"
            href={routes.isCabinetPath(location.pathname) ? routes.CABINET : routes.ROOT}
          >
            На главную
          </Button>
        </NotFoundContainer>
      </CenteredWrapper>
    </Container>
  );
};

export default UnexpectedError;
